import { render, staticRenderFns } from "./sign-request-v2.vue?vue&type=template&id=56fbde5c&"
import script from "./sign-request-v2.vue?vue&type=script&lang=js&"
export * from "./sign-request-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports